module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.panelFlag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [(_vm.addFlag) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Add a CNpro Account")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to CNpros")])]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Service Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.parent_category),
      expression: "cnpro.parent_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.parent_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCnproCategories(_vm.cnpro.parent_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Parent Category")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cnproCategories.length > 0),
      expression: "cnproCategories.length > 0"
    }],
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cnproCategories.length > 0),
      expression: "cnproCategories.length > 0"
    }],
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.category),
      expression: "cnpro.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Sub Category")]), _vm._v(" "), _vm._l((_vm.cnproCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.name),
      expression: "cnpro.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Service Name"
    },
    domProps: {
      "value": (_vm.cnpro.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.description),
      expression: "cnpro.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Your Service Description",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.cnpro.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Contact Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.address),
      expression: "cnpro.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address "
    },
    domProps: {
      "value": (_vm.cnpro.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.phone),
      expression: "cnpro.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone "
    },
    domProps: {
      "value": (_vm.cnpro.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.email),
      expression: "cnpro.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "E-mail",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.cnpro.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')) + " " + _vm._s(_vm.error_here.email))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Social Media Handles")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.facebook),
      expression: "cnpro.facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://web.facebook.com/MyName/"
    },
    domProps: {
      "value": (_vm.cnpro.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.twitter),
      expression: "cnpro.twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://twitter.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.instagram),
      expression: "cnpro.instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://www.instagram.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.instagram = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCnpro
    }
  }, [_vm._v("Submit Listing")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xs-12 fld-left"
  }, [(_vm.viewFlag) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active fld",
    attrs: {
      "role": "tabpanel",
      "id": "one"
    }
  }, [_c('div', [_c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                                    Service: " + _vm._s(_vm.cnpro.cnpro_category_name) + "\r\n                                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to CNpros")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toggleMenuActions
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("View Actions")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu-actions"
  }, [_c('a', {
    staticClass: " btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setPanel('edit', _vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Edit")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts', _vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View Quotes/Contracts")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', [_vm._v("Name: " + _vm._s(_vm.cnpro.cnpro_name))]), _vm._v(" "), _c('p', [_vm._v("City: " + _vm._s(_vm.cnpro.cnpro_city_name))]), _vm._v(" "), _c('p', [_vm._v("State: " + _vm._s(_vm.cnpro.cnpro_state_name))]), _vm._v(" "), _c('p', [_vm._v("Address: " + _vm._s(_vm.cnpro.cnpro_address))]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.cnpro.cnpro_email))]), _vm._v(" "), _c('p', [_vm._v("Phone: " + _vm._s(_vm.cnpro.cnpro_phone))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.cnpro.cnpro_description))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Social Media")]), _vm._v(" "), _c('p', [_vm._v("Facebook: " + _vm._s(_vm.cnpro.cnpro_facebook))]), _vm._v(" "), _c('p', [_vm._v("Twitter: " + _vm._s(_vm.cnpro.cnpro_twitter))]), _vm._v(" "), _c('p', [_vm._v("Instagram: " + _vm._s(_vm.cnpro.cnpro_instagram))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_image,
      "width": "150",
      "height": "150"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros')
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_id_card
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('label', [_vm._v("Change/Upload ID Card")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros_id_card')
      }
    }
  })])])])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('hr', {
    staticStyle: {
      "border-top": "dashed 1px #999"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: " btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setPanel('delete', _vm.cnpro)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Remove CNpro")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "two"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "three"
    }
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "four"
    }
  }, [_vm._v("...")])])]) : _vm._e(), _vm._v(" "), (_vm.editFlag) ? _c('div', {
    staticClass: "content fld-lft-adjust"
  }, [_c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Edit CNpro Account\r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Service Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_parent_category),
      expression: "cnpro.cnpro_parent_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.cnpro_parent_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCnproCategories(_vm.cnpro.cnpro_parent_category)
      }]
    }
  }, _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_category),
      expression: "cnpro.cnpro_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cnpro.cnpro_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cnproCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_name),
      expression: "cnpro.cnpro_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Service Name"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_description),
      expression: "cnpro.cnpro_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Your Service Description",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Contact Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_address),
      expression: "cnpro.cnpro_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_phone),
      expression: "cnpro.cnpro_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_email),
      expression: "cnpro.cnpro_email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "E-mail",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')) + " " + _vm._s(_vm.error_here.email))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Social Media Handles")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(30), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_facebook),
      expression: "cnpro.cnpro_facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://web.facebook.com/MyName/"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(31), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_twitter),
      expression: "cnpro.cnpro_twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://twitter.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(32), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_instagram),
      expression: "cnpro.cnpro_instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://www.instagram.com/MyName"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_instagram = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCnpro
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.deleteFlag) ? _c('div', {
    staticClass: "content fld-lft-adjust"
  }, [_c('form', [_c('div', {
    staticClass: "background-white p30 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Delete CNpro Account\r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), _vm._m(33), (_vm.cnpro.cnpro_delete_request != '') ? _c('p', [_c('b', [_vm._v("Remove Account Status: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.cnpro.cnpro_delete_request))])]) : _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you wish to Continue?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.cnpro.cnpro_delete_request == '') ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeCnpro
    }
  }, [_vm._v("Yes Continue")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.viewQuotePanel) ? _c('div', {
    staticClass: "fld-lft-adjust p20 m30"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff",
      "padding-top": "2em"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_c('u', [_vm._v("Contract Status")]), _vm._v(": "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    },
    style: ({
      background: _vm.contract.contract_status_color_code,
      color: '#fff',
      padding: '0.2em'
    })
  }, [_vm._v(_vm._s(_vm.contract.contract_status))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-xs pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts')
      }
    }
  }, [_vm._v("Back to Contracts")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    on: {
      "click": _vm.toggleMenuActions
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v("View Actions")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu-actions"
  }, [(_vm.contract.contract_quote == 'SET') ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewQuoteFlag', '')
      }
    }
  }, [_vm._v("View Quote")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_quote != 'SET') ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-compliants')
      }
    }
  }, [_vm._v("View Complaints")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_status_id != 8 && _vm.contract.contract_status_id != 5 && _vm.contract.contract_status_id != 6 && _vm.contract.contract_status_id != 7 && _vm.contract.contract_status_id != 3) ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.markWorkDone(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Mark Job As Complete")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_status_id == 8 || _vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#contract_pictures"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload/View Work Pictures")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 8) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "border": "2px solid #22baae"
    }
  }, [(_vm.contract.contract_status_id == 5 && _vm.contract.contract_complaint_status != 16) ? _c('p', [_c('b', [_vm._v("CNuser confirmed Job as Completed...")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Notice: ")]), _vm._v("Your Job is on a 48hrs time frame review ending on "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.contract.contract_expiry_date))])]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_complaint_status == 16) ? _c('p', [_vm._m(34), _vm._v(" Please resolve complaints with the CNuser")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You've Marked this Job as Completed")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Discussion Thread")]), _vm._v(" "), _vm._l((_vm.contract_threads), function(thread) {
    return _c('p', [_c('b', [_vm._v(_vm._s(thread.contract_thread_user_name) + ":")]), _vm._v(" " + _vm._s(thread.contract_thread_thread))])
  }), _vm._v(" "), _c('form', [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.contract.contract_status_id != 5) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.message),
      expression: "quote.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "placeholder": "Message",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.message = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {}, [(_vm.contract.contract_status_id != 5) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.replyQuote(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 3) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setQuotePanel
    }
  }, [_vm._v("Give a Quote")]) : _vm._e()])])])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fld-lft-adjust"
  }, [(_vm.viewQuoteFlag) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                Quote Details "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), (_vm.contract.contract_quote == 'SET') ? _c('div', {}, [(_vm.editQuoteFlag) ? _c('div', [_c('form', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(35), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_quote_description),
      expression: "contract.contract_quote_description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_quote_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_quote_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(36), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_material_details),
      expression: "contract.contract_material_details"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_material_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_material_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(37), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_labour_cost),
      expression: "contract.contract_labour_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_labour_cost)
    },
    on: {
      "change": function($event) {
        _vm.totalAfterServiceCharge = (_vm.contract.contract_labour_cost - (_vm.contract.contract_labour_cost * _vm.serviceCharge))
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_labour_cost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Your Pay Out: ₦" + _vm._s(_vm.totalAfterServiceCharge) + " , (@" + _vm._s(_vm.serviceChargeInPercentage) + "% Service Charge(incl. of VAT))")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(38), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.contract_work_duration),
      expression: "contract.contract_work_duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.contract_work_duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.contract_work_duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editQuote(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('br')]) : _c('div', [_c('p', [_c('b', [_vm._v("Quote Status:")]), _vm._v(" " + _vm._s(_vm.contract.contract_status))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Proposed Job Description:")]), _vm._v(" " + _vm._s(_vm.contract.contract_quote_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("List of Materials:")]), _vm._v(" " + _vm._s(_vm.contract.contract_material_details))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Labour Cost:")]), _vm._v(" ₦" + _vm._s(_vm.contract.contract_labour_cost))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Work Duration:")]), _vm._v(" " + _vm._s(_vm.contract.contract_work_duration) + " Days")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.contract_edit_status == '1') ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setEditQuote
    }
  }, [_vm._v("Edit Quote")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fld-lft-adjust"
  }, [(_vm.quotePanel) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('form', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(39), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.details),
      expression: "quote.details"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(40), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.materials),
      expression: "quote.materials"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.materials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.materials = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(41), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.labour_cost),
      expression: "quote.labour_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.labour_cost)
    },
    on: {
      "change": function($event) {
        _vm.totalAfterServiceCharge = (_vm.quote.labour_cost - (_vm.quote.labour_cost * _vm.serviceCharge))
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.labour_cost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Your Pay Out: ₦" + _vm._s(_vm.totalAfterServiceCharge) + " , (@" + _vm._s(_vm.serviceChargeInPercentage) + "% Service Charge)")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(42), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.duration),
      expression: "quote.duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.quote.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote.duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setQuote(_vm.contract.contract_id, _vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Submit Quote")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fld-lft-adjust"
  }, [(_vm.viewComplaints) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                Complaints on the Job \r\n                                                "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-contracts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), (_vm.contract.contract_contract_complaints && _vm.contract.contract_contract_complaints.length != 0) ? _c('div', _vm._l((_vm.contract.contract_contract_complaints), function(complaint, index) {
    return _c('div', [_c('p', [_vm._v(" " + _vm._s(++index) + ") " + _vm._s(complaint.contract_complaint) + " \r\n                                                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(complaint.contract_complaint_date) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), (complaint.contract_complaint_status == 15) ? _c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v("RESOLVED")]) : _vm._e()])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No Complaints made yet")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content fld-lft-adjust"
  }, [(_vm.contractsPanel) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\r\n                                                    Contract Requests \r\n                                                    "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), (_vm.cnpro.cnpro_contracts && _vm.cnpro.cnpro_contracts.length == 0) ? _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Contracts Request Yet")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getCnpro(_vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Back to Profile")])]) : _c('div', _vm._l((_vm.cnpro.cnpro_contracts), function(co, index) {
    return _c('div', [_c('div', {
      staticClass: "background-white p20 mb30"
    }, [_c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setContractThreadPanel(co, co.contract_contract_threads)
        }
      }
    }, [_c('h4', [_vm._v(_vm._s(++index) + ".   "), _c('i', {
      staticClass: "fa fa-file",
      staticStyle: {
        "padding": "0.1em",
        "font-size": "1.2em"
      }
    }), _vm._v(_vm._s(co.contract_ref))]), _vm._v(" "), _c('p', {
      staticClass: "pull-left"
    }, [_vm._v(" " + _vm._s(co.contract_contractor) + " - " + _vm._s(co.contract_request) + " - "), _c('span', {
      staticClass: "status-flag",
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        background: co.contract_status_color_code,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(co.contract_status))]), _vm._v(" "), (co.contract_status_id == 12) ? _c('span', [_vm._v(" - " + _vm._s(co.contract_job_status))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "pull-left status-flag",
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        background: co.contract_complaint_status_color_code,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(co.contract_complaint_status_name))])])])])])])
  }))]) : _vm._e()])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-offset-3",
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.noCnproSet) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30"
  }, [_vm._m(44), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a CNpro Account")])]), _vm._v(" "), _c('p')])]) : _c('div', {
    staticClass: "content col-md-12 col-sm-12 col-xs-12"
  }, [_vm._l((_vm.cnpros), function(cp, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-12 col-xs-12",
      staticStyle: {
        "padding": "1em",
        "border-bottom": "solid 1px rgb(230, 225, 225)"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCnpro(cp.cnpro_id)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-2 col-lg-2 col-xs-2 col-sm-2 fld-cir-img"
    }, [_c('img', {
      staticStyle: {
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.img_url + cp.cnpro_image,
        "width": "100",
        "height": "100"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 col-lg-10 col-xs-10 col-sm-10 fld-img-lft"
    }, [_c('h2', {
      staticStyle: {
        "padding": "0.5em"
      }
    }, [_vm._v(_vm._s(cp.cnpro_name))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.cnpros.length < 2) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('add', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a CNpro Account")]) : _vm._e()])], 2)])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "contract_pictures",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(46), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "506px",
      "max-height": "268px"
    },
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_1
    }
  }), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.workPicturesUpload($event, _vm.contract.contract_id, 'contract_work_image_1')
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(47), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "506px",
      "max-height": "268px"
    },
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_2
    }
  }), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.workPicturesUpload($event, _vm.contract.contract_id, 'contract_work_image_2')
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(48), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "506px",
      "max-height": "268px"
    },
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_3
    }
  }), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.workPicturesUpload($event, _vm.contract.contract_id, 'contract_work_image_3')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(49)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _c('img', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "loader",
      "src": require("../../../static/assets/img/loader.gif"),
      "height": "15px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Sub Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe your Service"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "page-title",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_vm._v("\r\n                                                                Profile Image And Identity Card\r\n                                                                "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Sub Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Service Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe your Service"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City: Abuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" You have requested to remove this CNpro Account,\r\n                                                    This account would be checked for any pending or unresovled Information,\r\n                                                    the process would take a minimum of 48hrs.\r\n                                                    "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Notice: ")]), _vm._v("You have some pending complaints on this job")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Proposed Job Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("List Of Materials "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Labour Cost "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Work Duration (in days)"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Proposed Job Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("List of Materials"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Labour Cost "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Work Duration (in days)"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My CNpro Accounts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not added any CNpro account "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Upload/View Work Pictures "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(" Maximum of 3 Images")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 1 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 2 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 3 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c3ad14"}!./src/components/CnproAccounts/template.html
// module id = 275
// module chunks = 0